import { CommonModule } from '@angular/common';
import { Component, computed, inject, input, output } from '@angular/core';
import { AuthService, QiraUser } from '@app/services/auth.service';
import { PaymentService } from '@app/services/payment.service';
import { ModalService } from '@app/components/modal/modal.service';
import { ProductListDialogComponent } from '@app/payment/product-list-dialog/product-list-dialog.component';
import { environment } from '@env';
import { TranslocoPipe } from '@jsverse/transloco';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-profile-subscription',
  templateUrl: './subscription.component.html',
  imports: [TranslocoPipe, CommonModule, ButtonModule],
})
export class ProfileSubscriptionComponent {
  user = input<QiraUser | undefined>(undefined);
  loading = input<boolean>(false);
  onChange = output<QiraUser | undefined>();

  authService = inject(AuthService);
  paymentService = inject(PaymentService);

  modalService = inject(ModalService);

  concactUrl = environment.qira_contact_url;

  trialLeftDays = computed(() => this.paymentService.trialLeftDays());
  subscriptionLeftDays = computed(() => this.paymentService.subscriptionLeftDays());
  userHasSubscription = computed(() => this.paymentService.userHasSubscription());
  customerPortalLink = computed(() => this.paymentService.customerPortalUrl());
  userSubscription = computed(() => this.user()?.subscription?.plan);
  subscriptionKey = computed(() => {
    const plan = this.user()?.subscription?.plan;
    return `profile.subscription.plan.${plan}`;
  });

  async openProductList() {
    await this.authService.loadUser();
    const userHasSubscription = this.userHasSubscription();

    // If the user has already a subscription, the open-productList-dialog-button should not be visible
    // The user would see the button to the stripe-customer-portal instead
    if (userHasSubscription && this.authService.currentUser()?.subscription?.plan !== 'trial') {
      this.showOutdatedMessage();
      return;
    }

    this._openProductList();
  }

  showOutdatedMessage() {
    this.modalService.confirm(
      'global.outdated.dialog.title',
      'global.outdated.dialog.content',
      'global.error.dialog.reloadButton',
      'global.cancel'
    ).then((confirmed) => {
      if (confirmed) {
        location.reload();
      }
    });
  }

  _openProductList() {
    this.modalService.open(ProductListDialogComponent, {}, 
      { 
        screen: 'auto',
        showCloseButton: true,
      });
  }
}
